/*
 * @Author: kamo9527 logen_mo@163.com
 * @Date: 2023-03-20 15:36:30
 * @LastEditors: jia.chen02
 * @LastEditTime: 2025-09-02 11:45:49
 * @FilePath: /zakcm-core-ticketsystem-web/src/utils/request.ts
 * @Description: ajax request
 */
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import router from "@/router";
// import baseUrl from "@/config/appConfig";
import { ElMessage } from "element-plus";
import { generateUniqueId } from "./common";
const languageIsen = localStorage.getItem("language") === "en";

let messageInstance: any = null;
const resetMessage = (options: any) => {
  //关闭上一个弹窗，继续下一个弹窗
  if (messageInstance) {
    messageInstance.close();
  }
  messageInstance = ElMessage(options);
};

axios.defaults.baseURL =
  process.env.VUE_APP_HOST === "prd" ? "https://backend.tilchinalink.com" : "";
// axios.defaults.baseURL = "https://zakcm-sit-tksys.in.za";
// request 请求拦截器
axios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const token: string = localStorage.getItem("token_value") || "";
    const requestId = generateUniqueId();
    const timestamp = Date.now().toString();
    if (config.headers) {
      config.headers.authentication = token;
      config.headers["requestId"] = requestId;
      config.headers["timestamp"] = timestamp;
    } else {
      config.headers = {
        authentication: token,
        requestId,
        timestamp,
      };
    }
    return config;
  },
  (err) => Promise.reject(err)
);

// ajax 全局错误处理
axios.interceptors.response.use(
  (response: AxiosResponse) => {
    /**
     * closeDefaultMessage ，是否关闭默认提示，默认关闭，默认false。
     */
    if (
      !response.config.headers?.closeDefaultMessage &&
      response.data.code !== 0
    ) {
      ElMessage.error(
        response.data.msg || (languageIsen ? "Request error" : "请求错误")
      );
    }
    return response.data;
  },
  (err: AxiosError) => {
    if (err.response) {
      const { pathname, search } = window.location;
      switch (err.response.status) {
        case 404:
          ElMessage.error(
            languageIsen ? "Request returned 404 error" : "请求发生404错误"
          );
          break;
        case 500:
          ElMessage.error(
            languageIsen ? "Request returned 500 error" : "请求发生500错误"
          );
          break;
        case 504:
          ElMessage.error(languageIsen ? "Request timed out" : "请求超时");
          break;
        // case 400: // 用户没有csrf-token
        case 401: // 用户没有登录态
          sessionStorage.setItem("redirectUrl", pathname + search); // 记录当前路由URL
          resetMessage({
            message: languageIsen ? "Please log in again" : "请重新登录",
            type: "error",
          });
          setTimeout(() => {
            router.replace(`/login`);
          }, 2000);
          break;
        default:
          ElMessage.error(languageIsen ? "Network error" : "网络异常");
          break;
      }
      return Promise.reject(err); // 返回接口返回的错误信息
    }
  }
);

// 通用请求响应类型
export interface ResponseType<T = any> {
  code: number;
  msg: string;
  data: T;
}

// 请求配置类型
export interface RequestConfig extends AxiosRequestConfig {
  /** 是否关闭默认提示，默认开启提示，默认false */
  closeDefaultMessage?: boolean;
}

/**
 * GET 请求方法
 * @param url 请求地址
 * @param params 请求参数
 * @param config 请求配置
 * @returns Promise<T> 直接返回 data 数据
 */
export async function GET<T = any>(
  url: string,
  params?: any,
  config?: RequestConfig
): Promise<T> {
  const res = await axios.get<ResponseType<T>>(url, { params, ...config });
  const response = res as unknown as ResponseType<T>;
  if (response.code === 0) {
    return response.data;
  }
  return Promise.reject(response);
}

/**
 * POST 请求方法
 * @param url 请求地址
 * @param data 请求数据
 * @param config 请求配置
 * @returns Promise<T> 直接返回 data 数据
 */
export async function POST<T = any, D = any>(
  url: string,
  data?: D,
  config?: RequestConfig
): Promise<T> {
  const res = await axios.post<ResponseType<T>>(url, data, config);
  const response = res as unknown as ResponseType<T>;
  if (response.code === 0) {
    return response.data;
  }
  return Promise.reject(response);
}

export default axios;
